import * as yup from 'yup';

const MAX_RESET_LINK_EMAIL_LENGTH = 254;

const FORBIDDEN_EMAIL_CHARACTERS_PATTERN = /[<>"'`\x00\r\n]/;

const JWT_COMPACT_FORMAT_PATTERN = /^[A-Za-z0-9._-]+$/;

const yupEmailSchema = yup.string().email();

function emailContainsForbiddenCharacters(email: string): boolean {
  return FORBIDDEN_EMAIL_CHARACTERS_PATTERN.test(email);
}

function isNonEmptyString(value: string | null | undefined): value is string {
  return typeof value === 'string' && value.length > 0;
}

function normalizeResetLinkEmail(email: string): string {
  return email.trim().toLowerCase();
}

export function isValidResetLinkEmail(
  value: string | null | undefined
): boolean {
  if (!isNonEmptyString(value)) {
    return false;
  }

  const trimmed = value.trim();

  if (trimmed === '') {
    return false;
  }

  if (trimmed.length > MAX_RESET_LINK_EMAIL_LENGTH) {
    return false;
  }

  if (emailContainsForbiddenCharacters(trimmed)) {
    return false;
  }

  return yupEmailSchema.isValidSync(trimmed);
}

export function isValidResetLinkToken(
  value: string | null | undefined
): boolean {
  if (!isNonEmptyString(value)) {
    return false;
  }

  return JWT_COMPACT_FORMAT_PATTERN.test(value);
}

type InvalidResetLinkParams = { isValid: false };
type ValidResetLinkParams = {
  isValid: true;
  normalizedEmail: string;
  token: string;
};
export type ResetLinkParamsValidation =
  | InvalidResetLinkParams
  | ValidResetLinkParams;

export function validateResetLinkParams(
  email: string | null | undefined,
  token: string | null | undefined
): ResetLinkParamsValidation {
  if (!isValidResetLinkEmail(email) || !isValidResetLinkToken(token)) {
    return { isValid: false };
  }

  if (!isNonEmptyString(email) || !isNonEmptyString(token)) {
    return { isValid: false };
  }

  return {
    isValid: true,
    normalizedEmail: normalizeResetLinkEmail(email),
    token
  };
}
